import { render, staticRenderFns } from "./projectPermissionTab.vue?vue&type=template&id=06c407c7&scoped=true&"
import script from "./projectPermissionTab.vue?vue&type=script&lang=js&"
export * from "./projectPermissionTab.vue?vue&type=script&lang=js&"
import style0 from "./projectPermissionTab.vue?vue&type=style&index=0&id=06c407c7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c407c7",
  null
  
)

export default component.exports